export const PROFILE_MESSAGES = {
  WRONG_OLD_PASSWORD: 'password.wrongOldPassword',
  MANAGE_NAME: 'password.manageName',
  MANAGE_PASSWORD: 'password.managePassword',
  OLD_PASSWORD: 'password.oldPasswordHere',
  NEW_PASSWORD: 'password.newPasswordHere',
  PASSWORD_LIMIT: 'password.passwordValidation',
}